import React from "react";
import { Link } from 'react-router-dom';
import { useRef, useState, useEffect, useContext } from "react";
import { useAuth } from "../context/AuthProvider.js";
import { Row, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { parseJwt } from "../utils/index.js";
import { getFromLS, setToLS } from "../utils/storage";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import { ToastContainer, toast } from "react-toastify";
import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";
import { result } from "lodash";

function Login() {
  let navigate = useNavigate();
  const auth = useAuth();
  
  const [username, setUser] = useState("");
  const [password, setPwd] = useState("");
  const [otp, setOtp] = useState("");
  const [requestOtp, setRequestOtp] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [success, setSuccess] = useState(false);
  const [activeFeatures, setActiveFeatures] = useState([]);
  const [rememberMe, setRememberMe] = useState(false);
  


  const signin = async (e) => {
    e.preventDefault();

    const url = `${process.env.REACT_APP_BASE_URI}/workflow/authenticate/`;


    const hashedPassword = CryptoJS.SHA256(password).toString();
    console.log(hashedPassword)

    fetch(url, {
      method: "POST",
      body: JSON.stringify({ Username: username, Password: hashedPassword }),

      headers: { "Content-type": "application/json; charset=UTF-8" },
    })
    .then(response => response.json())
    .then(data => {
      if (data.success == false) {
        setErrMsg(data.message);
        toast.error(data.message, {
          position: "bottom-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toastify-color-error",
        })
        return;
      }

     

      localStorage.setItem("token", data.Token);
      let firmId = parseJwt(data.Token).FirmId;
      localStorage.setItem("firmId", firmId);
      localStorage.setItem("username", data.Username);
      localStorage.setItem("usertype", data.UserType);
      localStorage.setItem("firmname", data.FirmName);
      localStorage.setItem("sendto", data.SendTo);
      if (data.UserType) {
        switch (data.UserType) {
          case 'Flow Builder':
            localStorage.setItem("defaultActiveKey", data.SendTo == "Default" ? "myflows" : "myapps")
            break;

          case 'Analyst':
            localStorage.setItem("defaultActiveKey", data.SendTo == "Default" ? "maintenancereport" : "myapps")
            break;

          case 'Firm Admin':
            localStorage.setItem("defaultActiveKey", data.SendTo == "Default" ? "myflows" : "myapps")
            break;

          case 'Super Admin':
            localStorage.setItem("defaultActiveKey", data.SendTo == "Default" ? "superadmin" : "superadmin")
            break;

        }
        }

        if (data.isMFARequired === 'N') {
          handleSuccessfulLogin(data);
        }

        // Bypass OTP if "Remember Me" is selected
        const savedUsername = Cookies.get('username');
      
        if(savedUsername) {
          const savedPassword = Cookies.get('password');

          if(savedUsername !== username) {
            requestOtpFunction(data);
          }
          else if (savedUsername === username && savedPassword !== password) {
            Cookies.remove('password');
            requestOtpFunction(data);
          }
          else if (savedUsername === username && savedPassword === password) {
            handleSuccessfulLogin(data);
          }
        }
        else {
        // Request OTP after successful login
        requestOtpFunction(data);
      }
    })
    .catch(error => console.error("Error:", error));
  };

  const handleSuccessfulLogin = (data) => {
    setSuccess(true);
          auth.login(username);
  
          const payload = { Username: username };
          const requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify(payload),
          };
  
          fetch(
            `${process.env.REACT_APP_BASE_URI}/workflow/subscriptions/features/`,
            requestOptions
          )
            .then(result => result.json())
            .then(result => {
              setToLS("active-features", result.data.FeatureCode);
              setActiveFeatures(result.data.FeatureCode);
              setTimeout(() => {
                if (getFromLS('active-features').length > 0) {
                  navigate("/dashboard", { replace: true });
                }
              }, 2000);
            })
            .catch(error => console.error("Error fetching features:", error));
  };

  const requestOtpFunction = (data) => {
    // API call to request OTP
    const url = `${process.env.REACT_APP_BASE_URI}/workflow/request_otp/`;

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${data.Token}` },
      body: JSON.stringify({ Username: username }),
    })
    .then(response => response.json())
    .then(otpData => {
      if (otpData.success) {
        setRequestOtp(true); // Show OTP input
      } else {
        toast.error(otpData.message);
      }
    })
    .catch(error => console.error("Error:", error));
  };

  const verifyOtp = (e) => {
    e.preventDefault();
  
    const url = `${process.env.REACT_APP_BASE_URI}/workflow/verify_otp/`;
  
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ Username: username, otp: otp }),
    })
      .then(response => {
        // Check the response status before parsing
        if (response.status === 403) {
          return response.json().then(data => {
            toast.error(data.message || 'Invalid OTP. Please try again.');
            window.location.reload(); // Reload the page on 403 error
          });
        }
        return response.json(); // Parse the response if it's not a 403
      })
      .then(data => {
        if (data.success) {
          // Proceed with login
          if (rememberMe) {
            Cookies.set('username', username, { expires: 7 }); // Store for 7 days
            Cookies.set('password', password, { expires: 7 });
          } else {
            Cookies.remove('username');
            Cookies.remove('password');
          }
          handleSuccessfulLogin(data);
        }else {
          toast.error(data.message);
        }
      })
      .catch(error => console.error("Error verifying OTP:", error));
  };
  
  var [i, j, k] = [0, 0, 0];

  var txt = `Welcome to \n`;
  var txt2 = `Cygnus Accounting Hub \n`
  var txt3 = `For best experience please use Chrome, Firefox or Edge browser.`
  var speed = 100;
  var speed2 = 200;
  var speed3 = 200;

  const typeWriter = () => {
    if (window.location.pathname == "/login" && i < txt.length) {
      let text = txt.charAt(i);
      document.getElementById("text1").innerHTML += text === "\n" ? "<br/>" : text;
      i++;
      setTimeout(typeWriter, speed);
    }
    if (window.location.pathname == "/login" && i == txt.length && j < txt2.length) {
      let text2 = txt2.charAt(j);
      document.getElementById("text2").innerHTML += text2 === "\n" ? "<br/>" : text2;
      j++;
      setTimeout(typeWriter, speed2);
    }
    if (window.location.pathname == "/login" && j == txt2.length && k < txt3.length) {
      let text3 = txt3.charAt(k);
      document.getElementById("text3").innerHTML += text3 === "\n" ? "<br/>" : text3;
      k++;
      setTimeout(typeWriter, speed3);
    }
  }
  useEffect(() => {
    if (window.location.pathname == "/login") {
      typeWriter();
    }
  }, [window.location.pathname])



  return (
    <Container fluid>
      <Row>
        <Col className="login-drop">
          <span id='text1'></span>
          <span id='text2'></span>
          <span id='text3'></span>
        </Col>
        <Col style={{ background: "#F0F0F0" }}>
          <div style={{ margin: "25% 5%", background: "#F0F0F0" }}>
            <div style={{ marginBottom: "5%" }}>
              <h3>{requestOtp ? "Enter OTP" : "Please login to enter"}</h3>
            </div>
            <Form onSubmit={requestOtp ? verifyOtp : signin}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>User name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="username"
                  name="user"
                  value={username}
                  onChange={(e) => setUser(e.target.value)}
                  disabled={requestOtp}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  name="password"
                  value={password}
                  onChange={(e) => setPwd(e.target.value)}
                  disabled={requestOtp}
                />
              </Form.Group>
              {requestOtp && (
                <div>
                  <Form.Group className="mb-3" controlId="formBasicOtp">
                    <Form.Label>OTP</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter OTP"
                      name="otp"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-3" controlId="formBasicCheckbox">
                    <Form.Check
                      type="checkbox"
                      label="Remember Me"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                  </Form.Group>
                </div>
              )}
              <Button variant="primary" type="submit" className="custom-button">
                {requestOtp ? "Verify OTP" : "Sign In"}
              </Button>
              <div className="mt-3">
                <Link to="/forgot-password" style={{ color: "#007bff", textDecoration: "none" }}>Forgot Password?</Link>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
